import { render, staticRenderFns } from "./l-upload.vue?vue&type=template&id=4de022d1&scoped=true"
import script from "./l-upload.vue?vue&type=script&lang=js"
export * from "./l-upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de022d1",
  null
  
)

export default component.exports